module.exports = __webpack_public_path__ + "img/featured-vehicle-row-23-ford.bb821c8e.jpg";